<template>
  <IconSolid
    icon="fa-chevron-right"
    class="transition-transform duration-300"
    :class="isActive ? 'rotate-180' : ''"
  />
</template>
<script setup>
  // Imports
  import { computed } from 'vue'
  // Props
  const props = defineProps({
    modelValue: Boolean,
  })
  // Computed
  const isActive = computed(() => props.modelValue)
</script>
